<template>
  <div>
    <!--账户信息 start-->
    <div class="account-info border-1px mb-15">
      <div class="d-flex flex-sm-row flex-column user-base-info border-bottom-1px">
        <div class="d-flex mr-sm-3">
          <div class="d-md-block d-none mr-3">
            <img :src="require('@/assets/images/m.png')" alt/>
          </div>

          <div class="pt-2">
            <div class="color-333 text-bold user-name mb-2">{{ viewUserName }}</div>
            <div class="d-flex user-tags mb-2">
              <div class="color-8a909a">UID: GRX{{ Getter_User_Info.id || '--' }}</div>
              <div class="d-none d-md-flex flex">
                <!--<span class="user-tag-md-span">
                <b class="green" style="height: 24px;">L{{ vipLevel }}</b>
                {{ $t('header.user.drop.vip.level') }}
                </span>-->
                <!--<div class="relative">
                  <span
                    class="user-tag-md-span"
                    style="border-radius: 8px;padding-left: 6px;margin-left: 0;margin-right: 8px;"
                    v-if="afAndPrInfo.affiliateLevel > 0 && !isUndefinedOrNullOrEmpty(afAndPrInfo.affiliateStatus)"
                  >
                    {{ afAndPrInfo.affiliateStatus }}
                  </span>
                  <p class="affiliate-expired" v-if="afAndPrInfo.affiliateExpired">{{$t('labels.acc.partnership.expiredUpgrade')}}</p>
                </div>-->
                <!--<v-tooltip bottom style="display: block;">
                  <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  v-if="
                    !isUndefinedOrNullOrEmpty(afAndPrInfo.partnerAccountStatus) &&
                    afAndPrInfo.partnerAccountStatus !== -1 &&
                    afAndPrInfo.partnerAccountStatus !== 0 &&
                    afAndPrInfo.partnerAccountStatus !== 4 &&
                    afAndPrInfo.partnerLevel > 0"
                  class="user-tag-md-span"
                  :class="{'pl30': afAndPrInfo.partnerLevelCode.length > 2 }"
                >
                  <b class="yellow-orange">L{{ afAndPrInfo.partnerLevelCode }}</b>
                  {{ afAndPrInfo.partnerStatus }}
                </span>
                  </template>
                  {{$t('common.validUntil') + ': ' + setTimeZone(afAndPrInfo.partnerExpiryDate)}}
                </v-tooltip>-->
              </div>
            </div>
            <div class="d-flex flex d-md-none user-tags-v2">
              <!--<span class="user-tag-span ml-5">
              <b class="green" style="height: 24px;">L{{ vipLevel }}</b>
              {{ $t('header.user.drop.vip.level') }}
              </span>-->
              <!--<div class="relative">
                <span
                  class="user-tag-span ml-5"
                  style="border-radius: 8px;padding-left: 6px;margin-left: 0;margin-right: 8px;"
                  v-if="afAndPrInfo.affiliateLevel > 0 && !isUndefinedOrNullOrEmpty(afAndPrInfo.affiliateStatus)"
                >
                  {{ afAndPrInfo.affiliateStatus }}
                </span>
                <p class="affiliate-expired" v-if="afAndPrInfo.affiliateExpired">{{$t('labels.acc.partnership.expiredUpgrade')}}</p>
              </div>
              <v-tooltip bottom style="display: block;">
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    v-if="
                      !isUndefinedOrNullOrEmpty(afAndPrInfo.partnerAccountStatus) &&
                      afAndPrInfo.partnerAccountStatus !== -1 &&
                      afAndPrInfo.partnerAccountStatus !== 0 &&
                      afAndPrInfo.partnerAccountStatus !== 4 &&
                      afAndPrInfo.partnerLevel > 0
                    "
                    class="user-tag-span"
                    :class="{'pl30': afAndPrInfo.partnerLevelCode.length > 2 }"
                  >
                    <b class="yellow-orange">L{{ afAndPrInfo.partnerLevelCode }}</b>
                    {{ afAndPrInfo.partnerStatus }}
                  </span>
                </template>
                {{$t('common.validUntil') + ': ' + setTimeZone(afAndPrInfo.partnerExpiryDate)}}
              </v-tooltip>-->
            </div>
            <div class="color-8a909a" :class="{'mt-5': afAndPrInfo.affiliateExpired}">
              {{ $t('header.user.drop.30d.vol') }}: {{ Getter_User_Vip.tradeVolume }} {{ Getter_User_Vip.tradeCoinSymbol }}
            </div>
          </div>
        </div>

        <div class="right-user">
          <div class="items-center">
            <div class="items-center-left">
              <!--<div class="realname-status-box">
                <div v-if="Getter_User_Info.primaryAuthStatus !== 1">
                  <svg class="iconfont-symbol font-17" aria-hidden="true">
                    <use xlink:href="#icon-icon-test8"></use>
                  </svg>
                  <span class="font-12 color-8a909a ml-2">未实名认证</span>
                </div>
                <div v-if="Getter_User_Info.primaryAuthStatus === 1">
                  <v-icon class="font-16 color-success" >check_circle</v-icon>
                  <span class="ml-2 color-success inline-block vertical-middle">已认证</span>
                </div>
              </div>
              <div v-if="Getter_User_Info.primaryAuthStatus === 1"><router-link to="/usercenter/realname-info" class="check-link">查看</router-link></div>-->
            </div>
            <div class="items-center-right">
              <!-- <v-btn
                class="no-shadow btn update-btn"
                :label="$t('labels.acc.upgradeToPartner')"
                @click="update"
              />-->
            </div>
          </div>
        </div>

        <div class="ml-sm-auto mt-sm-0 mt-2">
          <v-btn class="btn invite-btn" @click="invite" depressed>{{ $t('labels.acc.inviteFriend') }}</v-btn>
        </div>
      </div>

      <div class="d-flex flex-lg-row flex-column justify-lg-space-around authentication-status-box">
        <div class="authentication-item d-flex flex-fill align-center mb-lg-0 mb-2">
          <div class="d-sm-block d-none status-icon pr-20">
            <!--<span class="img-icon realname-status-icon unverified"></span>-->
            <svg class="iconfont-symbol" aria-hidden="true" v-if="Getter_User_Info.primaryAuthStatus !== 1">
              <use xlink:href="#icon-icon-test21"/>
            </svg>
            <svg class="iconfont-symbol" aria-hidden="true" v-if="Getter_User_Info.primaryAuthStatus === 1">
              <use xlink:href="#icon-icon-test20"/>
            </svg>
          </div>
          <div class="status-right-info">
            <div class="color-333 status-right-info-title" v-if="Getter_User_Info.primaryAuthStatus === 1">
              <div class="label-acc-kyc">
                <span>{{ $t('labels.acc.kyc') }}</span>
              </div>
              <p class="check-status">
                <span class="check-status-icon"></span>
                <span class="check-status-txt">{{ $t('labels.acc.pass') }}</span>
              </p>
            </div>
            <div class="color-333 status-right-info-title" v-if="Getter_User_Info.primaryAuthStatus !== 1">
              <div class="label-acc-kyc">
                <span>{{ $t('labels.acc.kyc') }}</span>
              </div>
              <p class="check-status">
                <span class="check-status-icon check-status-icon1"></span>
                <span class="check-status-txt">{{ $t('labels.acc.notPass') }}</span>
              </p>
            </div>
            <!-- <div class="color-8a909a">
              <span class="mr-30">24小时提币限额：2BTC</span>
              <span>24小时提币次数：1</span>
            </div>-->
          </div>
        </div>
        <div class="authentication-item d-flex flex-fill align-center">
          <div class="d-sm-block d-none status-icon pr-20">
            <!--<span class="img-icon senior-certification-status-icon verified"></span>-->
            <svg class="iconfont-symbol" aria-hidden="true" v-if="Getter_User_Info.advancedAuthStatus !== 1">
              <use xlink:href="#icon-icon-test19"/>
            </svg>
            <svg class="iconfont-symbol" aria-hidden="true" v-if="Getter_User_Info.advancedAuthStatus === 1">
              <use xlink:href="#icon-icon-test18"/>
            </svg>
          </div>
          <div class="status-right-info">
            <div class="color-333 status-right-info-title" v-if="Getter_User_Info.advancedAuthStatus === 1">
              <div class="label-acc-kyc">
                <span>{{ $t('labels.acc.advKyc') }}</span>
              </div>
              <p class="check-status">
                <span class="check-status-icon"></span>
                <span class="check-status-txt">{{ $t('labels.acc.pass') }}</span>
              </p>
            </div>
            <div class="color-333 status-right-info-title" v-if="Getter_User_Info.advancedAuthStatus !== 1">
              <div class="label-acc-kyc">
                <span>{{ $t('labels.acc.advKyc') }}</span>
              </div>
              <p class="check-status">
                <span class="check-status-icon check-status-icon1"></span>
                <span class="check-status-txt">{{ $t('labels.acc.notPass') }}</span>
              </p>
            </div>
            <!-- <div class="color-8a909a">
              <span class="mr-30">24小时提币限额：2BTC</span>
              <span>24小时提币次数：1</span>
            </div>-->
          </div>
        </div>
      </div>
      <!--TODO: hide affiliate and partner output-->
      <!--{{afAndPrInfo}}
      <br><br>
      {{partnerData}}
      <div></div>-->
      <!--<div class="partner-setting mb-15"
           v-if="partnerData.status > 0 || (partnerData.status === 0 && !partnerData.isInvitationExpired)">
        <div class="border-bottom-1px"></div>
        <ol>
          <li class="partner-setting-item clearfix">
            <div class="float-left left-partner-desc">
              <div class="partner-caption">
                <h6 class="partner-field-name">{{ $t('labels.acc.partnership') }}</h6>
                <span class="partner-field-introduce"
                      v-if="afAndPrInfo.enableJoinPartner && afAndPrInfo.partnerLevel === 0">
                  {{ $t('common.validUntil') }}: {{ setTimeZone(afAndPrInfo.partnerInvitationExpiry) }}
                </span>
                <span class="partner-field-introduce" v-if="afAndPrInfo.invitationExpired">
                  {{ $t('common.validUntil') }}: {{ setTimeZone(afAndPrInfo.partnerExpiryDate) }}
                </span>
                &lt;!&ndash;<span class="partner-field-introduce" v-if="afAndPrInfo.allowPartnerUpgrade && afAndPrInfo.partnerAccountStatus == 0">{{$t('common.expired')}}: {{ setTimeZone(afAndPrInfo.partnerExpiryDate) }}</span>&ndash;&gt;
              </div>
            </div>
            <div class="float-right mobile-margin">
              <span class="pending-upgrade mr-5" v-if="partnerData.expired">
                {{$t('labels.acc.partnership.expiredUpgrade')}}
              </span>
              <span class="pending-upgrade mr-5" v-if="partnerData.status == 5 && partnerData.pendingUpgradeName != ''">
                {{$t('labels.acc.partnership.pendingUpgrade').replace('{title}', partnerData.pendingUpgradeName)}}
              </span>
              &lt;!&ndash; if partner status is 6 (expired) &ndash;&gt;
              &lt;!&ndash; v-if="item.available && partnerData.status !== 6 && !partnerData.expired" &ndash;&gt;
              &lt;!&ndash; v-if="item.available && (partnerData.expired === 6 || partnerData.expired) && partnerData.level === item.id" &ndash;&gt;
              <v-btn
                v-for="(item, index) in partnerData.list"
                v-if="item.available && partnerData.status !== 6 && !partnerData.expired"
                style="min-width: 140px;margin: 5px 5px 0;"
                color="#1E49AC"
                class="upgrade-partner-btn mt-5"
                :key="index"
                @click="clickUpgradePartner(item)"
              >
                {{ $t('landing.partner.join') }}{{ item.displayName }} {{ partnerData.pendingUpgradeLevelCode ?
                `(${partnerData.pendingUpgradeLevelCode})` : '' }}
              </v-btn>
              &lt;!&ndash; if partner status is not 6 (expired) &ndash;&gt;
              <v-btn
                v-for="(item, index) in partnerData.list"
                style="min-width: 100px;margin: 5px 5px 0;"
                v-if="item.available && (partnerData.expired === 6 || partnerData.expired) && partnerData.level === item.id"
                color="#1E49AC"
                class="upgrade-partner-btn mt-5"
                :key="index"
                @click="clickUpgradePartner(item)"
              >
                {{ $t('actions.renew') }}
              </v-btn>
              <v-btn
                style="color:white"
                v-if="partnerData.status === 0"
                color="red"
                class="to-verify-btn mt-5 ml-2"
                @click="clickShowRejectPartnerInvModal"
              >
                {{ $t('actions.reject') }}
              </v-btn>
              &lt;!&ndash;  <q-btn
                 v-if="afAndPrInfo.allowPartnerUpgrade"
                 style="min-width: 150px;margin-top: 5px;"
                 class="to-verify-btn no-shadow" color="primary"
                 :label="$t('Upgrade Senior')"
               ></q-btn>
               <q-btn
                 v-if="afAndPrInfo.allowPartnerUpgrade"
                 style="min-width: 150px;margin-top: 5px;"
                 class="to-verify-btn no-shadow" color="primary"
                 :label="$t('Upgrade Top')"
               ></q-btn>&ndash;&gt;
            </div>
          </li>
        </ol>
      </div>-->
    </div>
    <!--账户信息 end-->

    <!--安全设置 start-->
    <div class="security-setting border-1px">
      <h2 class="font-18 color-333 mb-20">{{ $t('labels.acc.securitySettings') }}</h2>
      <div class="border-bottom-1px"></div>
      <ol>
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test14"/>
            </svg>
          </div>

          <div class="security-caption mr-8">
            <h6 class="security-field-name">{{ $t('labels.acc.bindEmail') }}</h6>
            <p class="security-field-introduce">{{ $t('labels.acc.bindEmail.desc') }}</p>
          </div>

          <div class="ml-md-auto mt-md-0 mt-3 align-self-start align-self-md-center d-flex flex-wrap">
            <div class="binding-text">{{ formatEmail(Getter_User_Info.email) }}</div>
            <v-btn
              class="to-verify-btn ml-3"
              label="验证"
              to="/usercenter/email-bind"
              outlined
              v-if="Getter_User_Info.emailStatus === 0"
            ></v-btn>
            <v-btn
              class="to-verify-btn ml-3"
              label="查看"
              to="/usercenter/email-bind"
              outlined
              v-if="Getter_User_Info.emailStatus === 1"
            ></v-btn>
          </div>
        </li>
        <!-- <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="left-security-desc">
            <div class="d-md-block d-none icon-wrap mr-sm-3">
              <svg class="iconfont-symbol" aria-hidden="true">
                <use xlink:href="#icon-icon-test15"></use>
              </svg>
            </div>
            <div class="security-caption">
              <h6 class="security-field-name">手机验证</h6>
              <p class="security-field-introduce">资产提现、修改密码及安全设置时需要输入手机验证码。</p>
            </div>
          </div>
          <div >
            <div class="binding-text">
              <div v-if="Getter_User_Info.phoneStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"></use>
                </svg>
                <span class="ml-2 color-8a909a">未绑定</span>
              </div>
              <div v-if="Getter_User_Info.phoneStatus === 1">
                <v-icon class="font-16 color-success" >check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">已绑定</span>
              </div>
            </div>
            <v-btn class="to-verify-btn ml-3"
                   label="验证"
                   outlined
                   to="/usercenter/phone-bind"
                   v-if="Getter_User_Info.phoneStatus === 0"></v-btn>
            <v-btn class="to-verify-btn ml-3"
                   label="查看"
                   outlined
                   @click="()=>{$router.push({path: '/usercenter/phone-bind',query: {isUpdate: 1}})}"
                   v-if="Getter_User_Info.phoneStatus === 1"></v-btn>
          </div>
        </li>-->
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test17"/>
            </svg>
          </div>

          <div class="security-caption">
            <h6 class="security-field-name security-field-name1">{{ $t('labels.ga') }}</h6>
            <p class="security-field-introduce">{{ $t('labels.acc.ga.desc') }}</p>
          </div>

          <div class="ml-md-auto mt-md-0 mt-3 d-flex flex-wrap justify-start justify-md-end align-center">
            <div class="binding-text">
              <!-- <div v-if="Getter_User_Info.gaStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"></use>
                </svg>
                <span class="ml-2 color-8a909a inline-block vertical-middle">{{ $t('labels.acc.notBind') }}</span>
              </div>-->
              <div v-if="Getter_User_Info.gaStatus === 1">
                <v-icon class="font-16 color-success">check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">{{ $t('labels.acc.bind') }}</span>
              </div>
            </div>
            <v-btn class="to-verify-btn ml-3" outlined @click="showGaModal()" v-if="Getter_User_Info.gaStatus === 1">
              {{$t('labels.unbind') }}
            </v-btn>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              to="/usercenter/google-verification-bind"
              v-if="Getter_User_Info.gaStatus === 0"
            >
              {{ $t('labels.setup') }}
            </v-btn>
            <!-- <v-btn class="to-verify-btn ml-3"
                   :label="$t('labels.view')"
                   outlined
                   @click="()=>{$router.push({path: '/usercenter/google-verification-bind'})}"
            v-if="Getter_User_Info.gaStatus === 1"></v-btn>-->
          </div>
        </li>
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test17"/>
            </svg>
          </div>

          <div class="security-caption">
            <h6 class="security-field-name security-field-name1">{{ $t('labels.maxRegister') }}</h6>
            <p class="security-field-introduce">{{ $t('labels.acc.maxRegister.desc') }}</p>
          </div>

          <div class="ml-md-auto mt-md-0 mt-3">
            <div class="binding-text">
              <!-- <div v-if="Getter_User_Info.gaStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"></use>
                </svg>
                <span class="ml-2 color-8a909a inline-block vertical-middle">{{ $t('labels.acc.notBind') }}</span>
              </div>-->
              <div v-if="Getter_User_Info.regWalletStatus == 1">
                <v-icon class="font-16 color-success">check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">{{ $t('labels.acc.bind') }}</span>
              </div>
            </div>
            <!--<v-btn class="to-verify-btn ml-3"
                   outlined
                   @click="showGaModal()"
                   :label="$t('labels.unbind')"
            v-if="Getter_User_Info.gaStatus === 1"></v-btn>-->
            <v-btn
              class="to-verify-btn ml-3"
              :disable="Getter_User_Info.regWalletStatus == 1"
              @click="maxWalletModal()"
              outlined
            >
              {{ $t('labels.setup') }}
            </v-btn>
            <!-- <v-btn class="to-verify-btn ml-3"
                   :label="$t('labels.view')"
                   outlined
                   @click="()=>{$router.push({path: '/usercenter/google-verification-bind'})}"
            v-if="Getter_User_Info.gaStatus === 1"></v-btn>-->
          </div>
        </li>
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test12"></use>
            </svg>
          </div>
          <div class="security-caption">
            <h6 class="security-field-name security-field-name1">{{ $t('labels.acc.mobile.verf') }}</h6>
            <!-- <p class="security-field-introduce">登录Europe时使用</p> -->
          </div>
          <div class="ml-md-auto mt-md-0 mt-3">
            <div class="binding-text">
              <div v-if="Getter_User_Info.mobileStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"></use>
                </svg>
                <span class="ml-2 color-8a909a inline-block vertical-middle">{{ $t('labels.acc.notSetup') }}</span>
              </div>
              <div v-if="Getter_User_Info.mobileStatus === 1">
                <v-icon class="font-16 color-success">check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">{{ $t('labels.acc.setup') }}</span>
              </div>
            </div>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              to="/usercenter/phone-bind"
              v-if="Getter_User_Info.mobileStatus === 0"
            >{{ $t('actions.setup') }}
            </v-btn>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              to="/usercenter/phone-bind"
              v-if="Getter_User_Info.mobileStatus === 1"
            >{{ $t('actions.modify') }}
            </v-btn>
          </div>
        </li>
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test12"/>
            </svg>
          </div>

          <div class="security-caption">
            <h6 class="security-field-name">{{ $t('labels.acc.loginPwd') }}</h6>
            <!-- <p class="security-field-introduce">登录Europe时使用</p> -->
          </div>

          <div class="ml-md-auto mt-md-0 mt-3">
            <div class="binding-text">
              <div v-if="Getter_User_Info.pwdStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"/>
                </svg>
                <span class="ml-2 color-8a909a inline-block vertical-middle">{{ $t('labels.acc.notSetup') }}</span>
              </div>
              <div v-if="Getter_User_Info.pwdStatus === 1">
                <v-icon class="font-16 color-success">check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">{{ $t('labels.acc.setup') }}</span>
              </div>
            </div>
            <v-btn
              class="to-verify-btn ml-3"
              outlined to="/usercenter/login-pwd-bind"
              v-if="Getter_User_Info.pwdStatus === 0"
            >
              {{ $t('actions.setup') }}
            </v-btn>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              to="/usercenter/login-pwd-bind"
              v-if="Getter_User_Info.pwdStatus === 1">
              {{ $t('actions.modify') }}
            </v-btn>
          </div>
        </li>
        <li class="d-flex flex-md-row flex-column security-setting-item">
          <div class="d-md-block d-none icon-wrap mr-sm-3">
            <svg class="iconfont-symbol" aria-hidden="true">
              <use xlink:href="#icon-icon-test13"/>
            </svg>
          </div>

          <div class="security-caption mr-8">
            <h6 class="security-field-name">{{ $t('labels.acc.txnPwd') }}</h6>
            <p class="security-field-introduce">{{ $t('labels.acc.txnPwd.desc') }}</p>
          </div>

          <div class="ml-md-auto mt-md-0 mt-3 d-flex flex-wrap justify-start justify-md-end align-center">
            <div class="binding-text">
              <div v-if="Getter_User_Info.paymentPasswordStatus === 0">
                <svg class="iconfont-symbol font-16" aria-hidden="true">
                  <use xlink:href="#icon-icon-test8"/>
                </svg>
                <span class="ml-2 color-8a909a inline-block vertical-middle">{{ $t('labels.acc.notSetup') }}</span>
              </div>
              <div v-if="Getter_User_Info.paymentPasswordStatus === 1">
                <v-icon class="font-16 color-success">check_circle</v-icon>
                <span class="ml-2 color-success inline-block vertical-middle">{{ $t('labels.acc.setup') }}</span>
              </div>
            </div>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              to="/usercenter/traders-pwd-bind"
              v-if="Getter_User_Info.paymentPasswordStatus === 0"
            >
              {{ $t('actions.setup') }}
            </v-btn>
            <v-btn
              class="to-verify-btn ml-3"
              outlined
              @click="() => {$router.push({ path: '/usercenter/traders-pwd-bind' });}"
              v-if="Getter_User_Info.paymentPasswordStatus === 1"
            >
              {{ $t('actions.modify') }}
            </v-btn>
          </div>
        </li>
        <!-- <li class="d-flex flex-md-row flex-column security-setting-item">
           <div class="left-security-desc">
             <div class="d-md-block d-none icon-wrap mr-sm-3">
               <svg class="iconfont-symbol" aria-hidden="true">
                 <use xlink:href="#icon-icon-test16"></use>
               </svg>
             </div>
             <div class="security-caption">
               <h6 class="security-field-name">防钓鱼码</h6>
               <p class="security-field-introduce">通过验证您设置的防钓鱼码，可防范假冒Europe的邮件和网站。</p>
             </div>
           </div>
           <div >
             <div class="binding-text">
               <div v-if="Getter_User_Info.antiFishingStatus === 0">
                 <svg class="iconfont-symbol font-16" aria-hidden="true">
                   <use xlink:href="#icon-icon-test8"></use>
                 </svg>
                 <span class="ml-2 color-8a909a inline-block vertical-middle">未设置</span>
               </div>
               <div v-if="Getter_User_Info.antiFishingStatus === 1">
                 <v-icon class="font-16 color-success" >check_circle</v-icon>
                 <span class="ml-2 color-success inline-block vertical-middle">已设置</span>
               </div>
             </div>
             <v-btn class="to-verify-btn ml-3"
                    label="设置"
                    outlined
                    to="/usercenter/prevent-deceive-code"
                    v-if="Getter_User_Info.antiFishingStatus === 0"></v-btn>
             <v-btn class="to-verify-btn ml-3"
                    label="修改"
                    outlined
                    to="/usercenter/prevent-deceive-code/1"
                    v-if="Getter_User_Info.antiFishingStatus === 1"></v-btn>
           </div>
        </li>-->
      </ol>
    </div>
    <!--安全设置 end-->
    <GaModal v-if="gaModalShow" @submit="unbindGa" :show.sync="gaModalShow" v-model="ga_code"/>
    <MaxRegisterModal
      v-if="maxWalletModalShow"
      :show.sync="maxWalletModalShow"
      :pkg-type="maxWalletPkgType"
      :title="$t('labels.maxRegister')"
      :desc="$t('max.register.desc.bind')"
      :medium="true"
      v-model="maxWalletModalShow"
    />
    <!-- {{joinPartnerModalShow}} -->
    <JoinPartnerModal
      :show.sync="joinPartnerModalShow"
      :item="joinPartnerItem"
      :title="joinPartnerTitle"
      :desc="joinPartnerDesc"
      :pending-invite-level="pendingUpgradeLevelCode"
      @refreshAffAndParInfo="refreshAffAndParInfo"
    />
    <RejectPartnerInvitation :show.sync="rejectPartnerInvModelShow" @refreshAffAndParInfo="refreshAffAndParInfo"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import { actionTypes } from '@/store/action-types';
  import { mutationTypes } from '../../../store/mutation-types';
  import tool from '@/common/js/tool';
  import { getterTypes } from '@/store/getter-types';
  import GaModal from '@/components/GaModal/GaModal';
  import { accountManagementApi } from '@/api/user/accountManagementApi';
  import MaxRegisterModal from '@/components/MaxRegisterModal/v2';
  import JoinPartnerModal from '@/components/JoinPartnerModal/JoinPartnerModal';
  import RejectPartnerInvitation from '@/components/RejectPartnerInvitation/RejectPartnerInvitation';
  import moment from 'moment';

  export default {
    name: 'AccountManagement',
    data() {
      return {
        // 保护项数量
        totalProtectItems: 5,
        gaModalShow: false,
        ga_code: '',
        addressId: '',
        unbind: false,
        vipLevel: '',
        maxWalletModalShow: false,
        maxWalletPkgType: 'BIND',
        joinPartnerModalShow: false,
        joinPartnerTitle: '',
        joinPartnerDesc: '',
        joinPartnerItem: {},
        rejectPartnerInvModelShow: false,
        pendingUpgradeLevelCode: '',
        partnerData: {
          level: 0,
          displayName: '',
          expired: true,
          status: -1,
          invitationExpiry: '',
          isInvitationExpired: true,
          pendingUpgradeName: '',
          pendingUpgradeLevel: 0,
          partnerExpiryDate: '',
          list: []
        },
        afAndPrInfo: {
          affiliateLevel: 0,
          affiliateStatus: '',
          enableJoinPartner: false,
          allowPartnerUpgrade: false,
          invitationExpired: false,
          partnerAccountStatus: 0,
          partnerInvitationExpiry: null,
          partnerLevelCode: '',
          partnerStatus: -1,
          affiliateExpired: null,
        }
      };
    },
    computed: {
      ...mapGetters([
        getterTypes.Getter_User_Info,
        getterTypes.Getter_User_Vip,
        getterTypes.GETTER_AFFILIATE_PARTNER_INFO,
        getterTypes.GETTER_PARTNER_INFO
      ]),
      // 用于展示的用户名
      viewUserName() {
        let userInfo = this.Getter_User_Info;
        if (userInfo.id) {
          return userInfo.email ? tool.formatEmail(userInfo.email) : userInfo.phone ? tool.formatPhone(userInfo.phone) : '--';
        } else {
          return '--';
        }
      },
      // 已启用的保护项
      hasUsedProtect() {
        let count = 0;
        let userInfo = this.Getter_User_Info;
        userInfo.phoneStatus === 1 ? count++ : 1;
        userInfo.gaStatus === 1 ? count++ : 1;
        userInfo.fundPasswordStatus === 1 ? count++ : 1;
        userInfo.primaryAuthStatus === 1 ? count++ : 1;
        userInfo.emailStatus === 1 ? count++ : 1;
        return count;
      }
    },
    watch: {
      gaModalShow(val) {
        this.ga_code = '';
      }
    },
    methods: {
      ...mapMutations([mutationTypes.SET_AFFILIATE_PARTNER_INFO, mutationTypes.SET_PARTNER_INFO]),
      ...mapActions([
        actionTypes.GET_USERINFO_ACTION,
        actionTypes.GET_USER_VIP_ACTION,
        actionTypes.GET_AFFILIATE_PARTNER_INFO_ACTION,
        actionTypes.GET_PARTNER_INFO_ACTION
      ]),
      invite() {
        this.$router.push({ name: 'invite' });
      },
      update() {
        this.$router.push('/usercenter/partner');
      },
      formatEmail: tool.formatEmail,
      showGaModal() {
        this.gaModalShow = true;
      },
      unbindGa(value) {
        const data = {
          // addressId: this.addressId,
          gaCode: value
        };
        accountManagementApi.setUnbindGA(data).then(res => {
          if (res.errcode === 0) {
            this.gaModalShow = false;
            this.GET_USERINFO_ACTION();
            this.successNotify(this.$t('success.ga.unbind'));
            // this.getList();
            // this.reInit();
          }
        });
      },
      maxWalletModal() {
        this.maxWalletModalShow = true;
      },
      getAffiliateAndPartnerInfo() {
        /*if (this.isEmpty(this.GETTER_AFFILIATE_PARTNER_INFO)) {
            this.GET_AFFILIATE_PARTNER_INFO_ACTION().then(() => {
              this.afAndPrInfo = this.GETTER_AFFILIATE_PARTNER_INFO;
            })
          } else {
            this.afAndPrInfo = this.GETTER_AFFILIATE_PARTNER_INFO;
          }*/
        this.GET_AFFILIATE_PARTNER_INFO_ACTION().then(() => {
          this.afAndPrInfo = this.GETTER_AFFILIATE_PARTNER_INFO;
          if (!this.isUndefinedOrNullOrEmpty(this.afAndPrInfo.affiliateExpiryDate) && this.afAndPrInfo.affiliateLevel != 1) {
            this.afAndPrInfo.affiliateExpired = moment().isAfter(this.setTimeZone(this.afAndPrInfo.affiliateExpiryDate));
          }
        });
      },
      getPartnerInfo() {
        /*if (this.isEmpty(this.GETTER_PARTNER_INFO)) {
            this.GET_PARTNER_INFO_ACTION().then(() => {
              this.partnerData = this.GETTER_PARTNER_INFO;
            })
          } else {
            this.partnerData = this.GETTER_PARTNER_INFO;
          }*/
        this.GET_PARTNER_INFO_ACTION().then(() => {
          this.partnerData = this.GETTER_PARTNER_INFO;
        });
      },
      clickUpgradePartner(item) {
        this.joinPartnerModalShow = true;
        this.pendingUpgradeLevelCode = this.partnerData.pendingUpgradeLevelCode || '';
        this.joinPartnerItem = item;
      },
      showSubscribePartner() {
        this.joinPartnerModalShow = false;
      },
      clickShowRejectPartnerInvModal() {
        this.rejectPartnerInvModelShow = true;
      },
      refreshAffAndParInfo() {
        this.joinPartnerModalShow = false;
        this.rejectPartnerInvModelShow = false;
        this.SET_AFFILIATE_PARTNER_INFO({});
        this.SET_PARTNER_INFO({});
        this.getAffiliateAndPartnerInfo();
        this.getPartnerInfo();
      }
    },
    created() {
      this.GET_USERINFO_ACTION();
      this.GET_USER_VIP_ACTION().then(res => {
        // this.vipLevel = this.Getter_User_Vip.vipId;
        this.vipLevel = this.Getter_User_Vip.vipName.substring(3); // remove 'VIP'
      });
      this.getAffiliateAndPartnerInfo();
      this.getPartnerInfo();
    },
    mounted() {
    },
    components: { GaModal, MaxRegisterModal, JoinPartnerModal, RejectPartnerInvitation }
  };
</script>

<style lang="stylus" scoped>
  @import 'account-management.scoped.styl';
  .pl30 {
    padding-left: 30px !important;
  }
  .relative {
    position: relative;
  }
  .pending-upgrade {
    font-size: 14px;
    color: red;
  }
  .affiliate-expired {
    position: absolute;
    font-size: 12px;
    left: -5px;
    right: 0;
    text-align: center;
    color:red;
  }
</style>
